import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const TextInput = ({
  name,
  label,
  control,
  errors,
  defaultValue,
  size,
  ...restProps
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ''}
      render={({ field }) => (
        <TextField
          {...field}
          minRows={size || 0}
          label={label}
          variant="outlined"
          fullWidth
          multiline
          size="small"
          slotProps={{
            htmlInput: {
              'aria-label': name,
            },
          }}
          error={!!errors?.[name]}
          helperText={errors?.[name]?.message}
          {...restProps}
        />
      )}
    />
  );
};

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  defaultValue: PropTypes.string,
  size: PropTypes.number,
};

export default TextInput;
